import $ from "jquery";

// Content-scoped boot passes extracted from src/article-scripts.js. Each
// function takes the region it operates on (an Element, the document, or a
// jQuery selection) plus — where the original code read free page globals —
// an env snapshot. article-scripts.js calls them at DOM-ready with the whole
// document (boot behavior unchanged); the post-unlock swap (tpm-lib/post-unlock.js)
// re-runs them on the freshly inserted .entry-content.

function toJQuery(root) {
	// Accept an existing jQuery selection (e.g. boot's $(".Article")) as-is.
	return root && root.jquery ? root : $(root);
}

/**
 * iframe sizing: google ads frames get a 15px bottom margin; wide frames go
 * full-width on mobile.
 */
export function sizeIframes(root, { isMobile = false } = {}) {
	toJQuery(root)
		.find("iframe")
		.each(function (_index, frame) {
			if (frame.id.substring(0, 17) == "google_ads_iframe") {
				frame.style["margin-bottom"] = "15px";
			} else if (parseInt(frame.width) > 350 && isMobile) {
				frame.width = "100%";
			}
		});
}

/**
 * Layout fix for full-size images on desktop prime articles: wide images get
 * pulled out to bleed past the column.
 */
export function fullBleedImages(
	root,
	{ singlePost = false, windowWidth } = {}
) {
	if (!singlePost) return;
	if (windowWidth === undefined) windowWidth = window.innerWidth;
	if (windowWidth <= 768) return;
	toJQuery(root)
		.find(
			".js_prime-article-content p img.size-full, .js_article-content p img.size-full"
		)
		.each(function () {
			if (this.offsetWidth > 700) {
				let w = (this.offsetWidth - 700) / 2;
				this.setAttribute("style", `margin-left: -${w}px`);
			}
		});
}

/**
 * fivepoints h2 renumbering.
 */
export function fivepointsHeads(root, { singlePost = false, category } = {}) {
	if (!singlePost || category !== "fivepoints") return;
	let num = 1;
	toJQuery(root)
		.find(".js_article-content h2")
		.each(function () {
			var newInnerHtml =
				'<div class="FivePoints__Num">' +
				num +
				'</div><div class="FivePoints__Text">' +
				$(this).html() +
				"</div>";
			$(this).addClass("FivePoints");
			$(this).html(newInnerHtml);
			num = num + 1;
		});
}

/**
 * figcaption expander.
 */
export function figcaptionToggles(root) {
	toJQuery(root)
		.find(".js_figcaption-toggle")
		.on("click", function () {
			$(this).parent().children().toggleClass("active");
		});
}

/**
 * Per-annotation wiring: activate the toggle UI (document-scoped — the
 * toggle/explainer live outside the content region) and wire each
 * annotation's control click. Returns the annotation selection so the boot
 * path can keep its document-level outside-click and checkbox handlers.
 */
export function initAnnotations(root) {
	const annotations = toJQuery(root).find(".js-annotation");
	if (!annotations.length) return annotations;
	$(".js_annotations-toggle").addClass("--active");
	$(".js_annotations-explainer").addClass("--active");
	annotations.each(function () {
		const anno = $(this);
		anno.find(".js_annotation-control").on("click", function () {
			anno.toggleClass("--visible");
		});
	});
	return annotations;
}

/**
 * Minipost layout: the author byline moves to after the first heading, the
 * copy-link moves inside it. Two passes, matching the boot order.
 */
export function arrangeMiniposts(root) {
	const $root = toJQuery(root);
	$root.find(".tpm-minipost-container").each(function () {
		const author = this.querySelector(".tpm-minipost-author");
		if (!author) return;
		const heading = this.querySelector(".wp-block-heading");
		if (!heading) return;
		heading.after(author);
	});
	$root.find(".tpm-minipost-container").each(function () {
		const copyLink = this.querySelector(".tpm-minipost-copy-link");
		if (!copyLink) return;
		const heading = this.querySelector(".wp-block-heading");
		if (!heading) return;
		heading.appendChild(copyLink);
	});
}

/**
 * Full re-run pass over swapped-in article content. Reads the page globals
 * the boot path received as free variables (is_mobile, single_post, category).
 */
export function reinitContent(root) {
	const w = typeof window !== "undefined" ? window : {};
	const env = {
		isMobile: !!w.is_mobile,
		singlePost: !!w.single_post,
		category: w.category,
	};
	sizeIframes(root, env);
	fullBleedImages(root, env);
	fivepointsHeads(root, env);
	figcaptionToggles(root);
	initAnnotations(root);
	arrangeMiniposts(root);
}
